import { NavMenuBottomComponent } from './nav-menu-bottom/nav-menu-bottom.component';
import { NavbarButtonNotifactionsComponent } from './navbar-button-notifactions/navbar-button-notifactions.component';
import { NavbarSearchCustomersComponent } from './navbar-search-customers/navbar-search-customers.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SideButtonComponent } from './side-button/side-button.component';
import { SideMenuCollapseComponent } from './side-menu-collapse/side-menu-collapse.component';
import { SidebarRightComponent } from './sidebar-right/sidebar-right.component';
import { SidebarComponent } from './sidebar/sidebar.component';

export const menuComponents = [
  SidebarComponent,
  NavbarComponent,
  SideButtonComponent,
  SideMenuCollapseComponent,
  NavbarButtonNotifactionsComponent,
  NavbarSearchCustomersComponent,
  NavMenuBottomComponent,
  SidebarRightComponent
];
